<template>
  <div v-bem>
    <h5 v-bem:label>{{ label }}</h5>
    <div v-bem:item>{{ value }}</div>
  </div>
</template>

<script>
export default {
  name: 'SummaryItem',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use 'sass:map';

.summary-item {
  @at-root #{&}__label {
    margin-bottom: utils.f-convert-to-rem(4);
    color: map.get(utils.$v-colors, 'rw-grey-06');
    font-size: utils.f-rem-calc(12);
    line-height: 1.2em;
  }

  @at-root #{&}__item {
    @include utils.bs-media-breakpoint-down(md) {
      font-size: utils.f-rem-calc(15);
      font-weight: 500;
    }
  }
}
</style>
